import Head from "next/head";
import { AchievementsGuestPage } from "../../components/achievementsGuest";

const Achievements = () => {
  const IWidth = "600";
  const IHeight = "315";
  const image = "/static/images/achievements/metaAch.png";
  const title = "Виртуальные бэйджи от DonorSearch!";
  const description = "Мотивационная программа для доноров сообщества DonorSearch! Отмечайте свои донации, совершайте пожертвования, привлекайте друзей в проект и открывайте уникальные ачивки, отмечающие вклад в развитие донорского движения. Собирайте коллекцию достижений на своем пути донора.";

  return (
    <>
      <Head>
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="vk:image" content={image} />
        <meta property="vk:image:width" content={'537'} />
        <meta property="vk:image:height" content={'282'} />
        <meta property="twitter:image" content={image} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content={IWidth} />
        <meta property="og:image:height" content={IHeight} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
        <link rel="image_src" href={image} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <AchievementsGuestPage />
    </>
  );
};

export default Achievements;